import settings from './settings.middleware'
import themes from './themes.middleware';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    settings,
    themes
]
